module.exports = __webpack_public_path__ + "assets/images/14-4.jpg";